// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon11(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M15.716 15.383h-2.787a.333.333 0 1 0 0 .666h2.787a.333.333 0 1 0 0-.666Z" />
        <path d="M27.754 15.4v-1.774a.333.333 0 0 0-.334-.333h-2.4l.237-4.82c.353-1.867.3-1.6.31-1.633l.27-1.427c.34-.03.669-.144.953-.333.774-.527.84-1.214.954-1.817A2.043 2.043 0 0 0 26.117.877L21.564 0a2.05 2.05 0 0 0-2.39 1.627l-.094.506a2.047 2.047 0 0 0 .624 1.883l-.82.25a8.854 8.854 0 0 0-4.06 2.624c-.974-2.667-2.667-3.793-4.227-5.034a.333.333 0 0 0-.5.104L9.26 3.54a8.79 8.79 0 0 0-1.016 4.727c-2.567-1.2-4.5-.81-6.55-.574a.333.333 0 0 0-.284.427l.527 1.71a8.856 8.856 0 0 0 2.457 3.91v1.666a3.18 3.18 0 0 0-2.667 4.184l2.237 6.6a4.473 4.473 0 0 0 2.773 2.787c-.537.49-.493 1.023-.493 1.496A1.52 1.52 0 0 0 7.764 32h16.62a1.52 1.52 0 0 0 1.52-1.517v-.413a1.508 1.508 0 0 0-.48-1.1 4.459 4.459 0 0 0 2.77-2.787l2.236-6.6a3.181 3.181 0 0 0-2.676-4.183Zm-4.2-2.107.113-3a.333.333 0 0 0-.667 0l-.116 3.034H18.28l1.84-5.424 4.457.847-.223 4.576-.8-.033Zm-3.267-6.07.193-1 4.37.83-.193 1-4.37-.83Zm4.88-1.85-.193 1-4.37-.817.193-1 4.37.817ZM19.734 2.26l.096-.507a1.38 1.38 0 0 1 1.354-1.12c.18 0-.167-.056 4.81.89a1.38 1.38 0 0 1 1.096 1.61c-.106.56-.133 1.02-.666 1.39a1.37 1.37 0 0 1-1.03.214L20.84 3.87a1.373 1.373 0 0 1-1.106-1.61Zm-.667 2.667 1.03-.334c-.263 1.397-.21 1.134-.22 1.167l-.313 1.647-1.947 5.763-.153.123H15.05l2.797-4.27a.333.333 0 1 0-.56-.357l-3.033 4.637h-.96a8.197 8.197 0 0 1 5.783-8.393l-.01.016Zm-9.22-1.07.65-1.227 1.087.86a8.206 8.206 0 0 1 2.75 4.023 8.863 8.863 0 0 0-1.637 4l-.813-3.877a.332.332 0 0 0-.605-.117.335.335 0 0 0-.049.25l1.154 5.524H11.08a8.22 8.22 0 0 1-1.233-9.436ZM2.167 8.31l1.377-.16a8.18 8.18 0 0 1 4.79.91A8.736 8.736 0 0 0 10 13.04l-3.313-2.17a.334.334 0 0 0-.54.212.333.333 0 0 0 .187.348l2.846 1.863H4.887c-1.823-1.666-2.22-3.323-2.72-4.983Zm22.217 20.91a.854.854 0 0 1 .853.85v.403a.855.855 0 0 1-.853.86H7.764a.853.853 0 0 1-.854-.85v-.413a.853.853 0 0 1 .854-.85h16.62Zm5.416-9.85-2.236 6.596a3.806 3.806 0 0 1-3.607 2.587H8.19a3.807 3.807 0 0 1-3.606-2.587l-2.25-6.596a2.51 2.51 0 0 1 2.38-3.334h5.433a.333.333 0 1 0 0-.666H5.06v-1.41h22.027v1.423h-6.863a.333.333 0 1 0 0 .667h7.196a2.511 2.511 0 0 1 2.38 3.32Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon11;
